import React, {useEffect, useState} from 'react';
import {Link, Redirect} from 'react-router-dom';
import { makeStyles } from '@material-ui/core/styles';
import Header from './Header';
import {Button, IconButton, LinearProgress, Typography} from "@material-ui/core";

import StyledButton from "./StyledButton";
import TextareaAutosize from "@material-ui/core/TextareaAutosize";
import {shallowEqual, useDispatch, useSelector} from "react-redux";
import { useClipboard } from 'use-clipboard-copy';
import Tooltip from '@material-ui/core/Tooltip';
import ErrorIcon from '@material-ui/icons/Error';

import * as Actions from "../../redux/actions";
import {isRTL} from "../../utils";
import {InsertDriveFile, CloudUpload} from "@material-ui/icons";


const useStyles = makeStyles(theme => ({
    root: {
        backgroundColor: 'rgba(247, 247, 249, 0.5)',
    },
    main: {
        background: '#FFFFFF',
        borderRadius: '2px',
        width: '310px',
        display: 'flex',
        margin: '0 auto 10px',
        alignItems: 'center',
        flexDirection: 'column'
    },
    button: {
        width: '144px',
        margin: '4px',
        border: 'none',
        background: 'rgba(0, 178, 152, 0.15)',
        borderRadius: '2px',
        height: '33px',
        '&:hover' : {
            backgroundColor: 'rgba(0, 178, 152, 0.35)',
            cursor: 'pointer',
        },
        '&:focus, &:active' : {
            backgroundColor: 'rgba(0, 178, 152, 1)',
            cursor: 'pointer',
        },
        '&:focus span, &:focus svg path, &:active span, &:active svg path': {
            color: '#fff',
            fill:  '#fff',
        },
    },
    buttonUpload: {
        width: '40px',
        margin: '4px',
        border: 'none',
        background: 'rgba(0, 178, 152, 0.15)',
        borderRadius: '2px',
        height: '33px',
        '&:hover' : {
            backgroundColor: 'rgba(0, 178, 152, 0.35)',
            cursor: 'pointer',
        },
        '&:focus, &:active' : {
            backgroundColor: 'rgba(0, 178, 152, 1)',
            cursor: 'pointer',
        },
        '&:focus span, &:focus svg path, &:active span, &:active svg path': {
            color: '#fff',
            fill:  '#fff',
        },
    },
    list: {
        width: '100%'
    },
    listItem: {
        display: 'flex',
        flexDirection: 'row',
        height: '32px',
        '&:hover' : {
            backgroundColor: 'rgba(36, 232, 255, 0.04)',
            cursor: 'pointer'
        },
        '&.Mui-selected': {
            backgroundColor: 'rgba(18, 116, 228, 0.05)'
        },
        '& > p': {
            flexGrow: 1,
            fontSize: '14px',
            fontFamily: 'Assistant'
        }
    },
    description: {
        padding: '12px',
        fontFamily: 'Assistant',
        fontSize: '13px',
        fontWeight: 'normal',
        fontStyle: 'normal',
        fontStretch: 'normal',
        letterSpacing: '0.2px',
        color: '#595959',
        marginBottom: '10px'
    },
    progress: {
        marginTop :'12px',
        width: '74%'
    },
    deleteButton: {
        width: '11px',
        height: '11px',
    },
    deleteIcon: {
        width: '11px',
        height: '11px',
    },
    link: {
        padding: '0 20px',
        lineHeight: '33px',
        background: '#1174E5',
        textAlign: 'center',
        display: 'flex',
        margin: '0 4px',
        textDecoration: 'none',
        alignItems: 'center',
        flexDirection: 'row'
    },
    span: {
        color: '#fff',
        paddingLeft: '8px',
        fontWeight: '700',
        fontSize:' 10px',
        fontFamily: 'Nunito',
    },
    textArea: {
        width: '294px',
        fontSize: '12px',
        lineHeight: '15px',
        padding: '15px',
        boxSizing: 'border-box',
        background: 'rgba(247, 247, 249, 0.5)',
        border: '1px solid #F7F7F9',
        borderRadius: '2px',
        marginBottom: '12px',
        fontFamily: 'Nunito',
        '&::placeholder': {
            color: '#030229',
            opacity: '1',
        },
    },
    textAreaResult: {
        width: '294px',
        padding: '15px',
        boxSizing: 'border-box',
        background: 'rgba(247, 247, 249, 0.5)',
        border: '1px solid #F7F7F9',
        borderRadius: '2px',
        marginBottom: '12px',
        fontFamily: 'Nunito',
        margin: '5px 0',
    },
    titleKeep: {
        color: '#1174E5',
        fontFamily: 'Nunito',
        fontSize: '9px',
        fontWeight: '700',
        fontStyle: 'normal',
    },
    colorOne: {
        color: '#9411AC',
    },

    bgOne: {
        border: 'none',
        background: 'rgba(148, 17, 172, 0.15)',
        borderRadius: '2px',
    },
    titleBack: {
        color: '#9411AC',
        fontFamily: 'Nunito',
        fontSize: '9px',
        fontWeight: '700',
        fontStyle: 'normal',
        textDecoration: 'none',
        marginLeft: '10px',
        cursor: "pointer",
    },
    titleBack2: {
        color: '#9411AC',
        fontFamily: 'Nunito',
        fontSize: '9px',
        fontWeight: '700',
        fontStyle: 'normal',
        textDecoration: 'none',
        marginLeft: '5px',
    },
    noBg: {
        background: 'none',
        minWidth: 'auto',
        '&:hover': {
            background: 'none',
        },
    },
    styleBlock: {
        display: 'flex',
        paddingLeft: '20px',
        width: '100%',
        boxSizing: 'border-box',
        justifyContent: 'center',
        '& p': {
            color: 'rgba(148, 17, 172, 0.8)',
            fontWeight: '700',
            margin: '6px 0',
            fontSize:' 10px',
            fontFamily: 'Nunito',
            cursor: 'pointer',
            '& span span': {
                paddingLeft: '8px',
                color: 'rgba(148, 17, 172, 0.8)',
                fill:  'rgba(148, 17, 172, 0.8)',
            }
        },
    },
    title: {
        color: '#030229',
        fontFamily: 'Nunito',
        fontSize: '10px',
        fontWeight: '800',
        fontStyle: 'normal',
    },
    styleForBlockSuggest: {
        display: 'flex',
        marginTop: '20px',
        justifyContent: 'space-between',
        width: '100%',
        alignItems: 'center',
        paddingLeft: '10px',
        boxSizing: 'border-box',
    },
    textField: {
        marginLeft: '40px',
        '& :before' : {
            display: 'none',
        },
        '& input' : {
            background: '#FBFBFC',
            border: '1px solid #F7F7F9',
            borderRadius: '2px',
            padding: '4px 5px',
            '& :before' : {
                display: 'none',
            },
        },
        '& input::placeholder': {
            color: '#030229',
            opacity: '1',
        },
    },
    empty: {
        '& input' : {
            border: '1px solid #FF7070',
        }
    },
    aiError: {
        background: 'rgba(255, 255, 255, 0.1)',
        border: '1px solid rgba(255, 89, 89, 0.1)',
        boxShadow: '0px 4px 20px rgba(0, 0, 0, 0.03)',
        borderRadius: '4px',
        width: '294px',
        boxSizing: 'border-box',
        marginBottom: '12px',
        fontFamily: 'Nunito',
        marginTop: '20px',
    },
    titleAiError: {
        color: '#FF5959',
        background: 'rgba(255, 89, 89, 0.15)',
        borderRadius: '4.2px 4.2px 1px 1px;',
        height: '22px',
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: '10px',
        lineHeight: '14px',
        display: 'flex',
        alignItems: 'center',
        textAlign: 'center',
        justifyContent: 'center',
    },
    aiErrorContent: {
        padding: '30px 20px 20px 20px',
    },
    aiErrorIcon: {
        display: 'flex',
        width: '100%',
        marginBottom: '15px',
    },
    aiErrorText : {
        fontFamily: 'Nunito',
        fontStyle: 'normal',
        fontWeight: '700',
        fontSize: '11px',
        display: 'flex',
        alignItems: 'center',
        color: '#FF5959',
    },
    inputCheck: {
        marginLeft: '-20px',
        zIndex: '1',
        marginTop: '7px',
    },
    inputCheckError: {
        marginLeft: '-15px',
        zIndex: '1',
        marginTop: '9px',
    },
    error: {
        background: 'rgba(247, 247, 249, 0.5)',
        border: '1px solid rgba(255, 89, 89, 0.15)',
        borderRadius: '2px',

        '&::placeholder': {
            color: 'rgba(255, 89, 89, 0.5)',
        },
    },
    styleBlockForCheckbox: {
        display: 'flex',
        paddingLeft: '20px',
        width: '100%',
        boxSizing: 'border-box',
        justifyContent: 'left',
        marginBottom: '6px',
        '& span': {
            color: '#505050',
            fontWeight: '700',
            fontSize:' 10px',
            fontFamily: 'Nunito',
            cursor: 'pointer',
        },
    },
    bgSecond: {
        border: 'none',
        background: 'rgba(0, 178, 152, 0.15)',
        borderRadius: '2px',
        margin: '0',
        boxSizing: 'border-box',
        height: '33px',
        '&:hover' : {
            backgroundColor: 'rgba(0, 178, 152, 0.35)',
            cursor: 'pointer',
        },
        '&:focus, &:active' : {
            backgroundColor: 'rgba(0, 178, 152, 1)',
            cursor: 'pointer',
        },
        '&:focus span, &:focus svg path, &:active span, &:active svg path': {
            color: '#fff',
            fill:  '#fff',
        },
    },
    bgSecondFetchPatent: {
        border: '1px solid rgba(0, 178, 152, 0.15)',
        background: '#fff',
        borderRadius: '2px',
        margin: '0',
        boxSizing: 'border-box',
        height: '33px',
        '&:hover' : {
            backgroundColor: 'rgba(0, 178, 152, 0.35)',
            cursor: 'pointer',
        },
        '&:focus, &:active' : {
            backgroundColor: 'rgba(0, 178, 152, 1)',
            cursor: 'pointer',
        },
        '&:focus span, &:focus svg path, &:active span, &:active svg path': {
            color: '#fff',
            fill:  '#fff',
        },
    },
    colorSecond: {
        color: '#00B298',
        textTransform: 'capitalize',
    },
}));

export default function AskPatent({}) {
    const classes = useStyles();
    const [file, setFile] = useState(null);
    const [isLoading, setLoading] = useState(false);

    const dispatch = useDispatch();
    const clipboard = useClipboard();
    const promptAiForPatent = useSelector(state => state.document.promptAiForPatent)
    const promptAi = useSelector(state => state.document.promptAi)
    const promptAiResult = useSelector(state => state.document.promptAiResult)
    const promptAiResultUploadArray = useSelector(state => state.document.promptAiResultUploadArray)
    const promptAiResultPatentClaimsArray = useSelector(state => state.document.promptAiResultPatentClaimsArray)

    const contextData = useSelector(state => state.document.contextData)
    const promptAiError = useSelector(state => state.document.promptAiError)
    const promptAiErrorText = useSelector(state => state.document.promptAiErrorText)
    const [question, setQuestion] = useState('');
    const [result, setResult] = useState(promptAiResult);
    const [emptyQuestion, setEmptyQuestion] = useState(undefined);

    const [redirectPage, setRedirectPage] = useState(undefined);

    const RTL = isRTL(promptAi);

    useEffect(() => {
        const fetchData = async () => {
            if (promptAiForPatent !== '' && promptAiForPatent) {
                try {
                    setLoading(true);
                    await dispatch(Actions.findPatentsWithAI(promptAiForPatent));
                } finally {
                    setLoading(false);
                }
            }
        };

        fetchData();
    }, [, promptAiForPatent]);

    useEffect( () => {
        setResult(promptAiResult)
    }, [promptAiResult] );

    const handleClick = () => {
        clipboard.copy(result);
    }

    const handleAskPatentClick = async () => {
        console.log('question', question)
        if(question && question.length > 0) {
            setEmptyQuestion(false);
            await setLoading(true);
            await dispatch(Actions.askAiMainForPatent( question ));
            await setLoading(false);
        } else {
            setEmptyQuestion(true);
        }
    };

    // console.log('promptAiResultPatentClaimsArray', promptAiResultPatentClaimsArray)
    // console.log('promptAiResultUploadArray', promptAiResultUploadArray)
    const handleAskAiClick = async () => {
        if (question && question.length > 0) {
            setEmptyQuestion(false);
            await setLoading(true);

            let prepareQuestion = '';

            let documentDescriptions = [];

            if (promptAiResultPatentClaimsArray.length > 0) {
                const patentDescriptions = promptAiResultPatentClaimsArray.map((doc) => {
                    return `<patent claim: ${doc.filename}>: ${doc.text}`;
                });
                documentDescriptions = [...documentDescriptions, ...patentDescriptions];
            }

            if (promptAiResultUploadArray.length > 0) {
                const uploadDescriptions = promptAiResultUploadArray.map((doc) => {
                    return `<uploaded document: ${doc.filename}>: ${doc.text}`;
                });
                documentDescriptions = [...documentDescriptions, ...uploadDescriptions];
            }



            if (documentDescriptions.length > 0) {
                prepareQuestion = `${documentDescriptions.join(' ')} My question: ${question}`;
            } else {
                prepareQuestion = `My question: ${question}`;
            }

            await dispatch(Actions.askAi(prepareQuestion, '', '', contextData));
            await setLoading(false);
        } else {
            setEmptyQuestion(true);
        }
    };


    const handleBack = async () => {
        await dispatch(Actions.clearAllAiPrompt());
        setRedirectPage(`/`)
    };

    const handleFileChange = async (event) => {
        const selectedFile = event.target.files[0];
        setFile(selectedFile);

        if (selectedFile) {
            const formData = new FormData();
            formData.append('file', selectedFile);

            setLoading(true);

            await dispatch(Actions.uploadPatent( formData ));

            setLoading(false);
        }
    };

    return  redirectPage ? <Redirect to={redirectPage} /> : (
        <div className={classes.root}>
            <Header showButton={false} />
            <div className={classes.main}>
                <div style={{display: 'flex', marginBottom: '12px', justifyContent: 'space-between', width: '100%', alignItems: 'center', marginTop: '10px',}}>
                    <span className={classes.titleBack} onClick={handleBack}>
                        <svg className={classes.svg} width="10" height="9" viewBox="0 0 10 9" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path d="M9 5C9.27614 5 9.5 4.77614 9.5 4.5C9.5 4.22386 9.27614 4 9 4V5ZM0.646446 4.14645C0.451184 4.34171 0.451184 4.65829 0.646446 4.85355L3.82843 8.03553C4.02369 8.2308 4.34027 8.2308 4.53553 8.03553C4.7308 7.84027 4.7308 7.52369 4.53553 7.32843L1.70711 4.5L4.53553 1.67157C4.7308 1.47631 4.7308 1.15973 4.53553 0.964466C4.34027 0.769204 4.02369 0.769204 3.82843 0.964466L0.646446 4.14645ZM9 4L1 4V5L9 5V4Z" fill="#9411AC"/>
                        </svg>
                        <span className={classes.titleBack2}>Back</span>
                    </span>


                    {isLoading &&  <LinearProgress color="primary" className={classes.progress}/>}

                            <Button
                                variant="contained"
                                component="label"
                                className={classes.buttonUpload}
                            >
                                <CloudUpload />
                                <input
                                    type="file"
                                    hidden
                                    onChange={handleFileChange}
                                />
                            </Button>
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                    {RTL ? (
                        <div dir={"rtl"} style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                            {promptAiResultPatentClaimsArray.length > 0 && (
                                <>
                                    <Typography className={classes.title} style={{ width: '100%', textAlign: 'center', marginBottom: '15px' }}>
                                        פטנטים נמצאו
                                    </Typography>

                                    <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', width: '100%', marginBottom: '15px' }}>
                                        {promptAiResultPatentClaimsArray.map((item, index) => (
                                            <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '15px' }}>
                                                <InsertDriveFile />
                                                <Typography className={classes.title} style={{ textAlign: 'center', marginTop: '5px' }}>
                                                    {item.filename}
                                                </Typography>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                            {promptAiResultPatentClaimsArray.length > 0 && (
                                <>
                                    <Typography className={classes.title} style={{ width: '100%', textAlign: 'center', marginBottom: '15px' }}>
                                        Patents were found
                                    </Typography>

                                    <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', width: '100%', marginBottom: '15px' }}>
                                        {promptAiResultPatentClaimsArray.map((item, index) => (
                                            <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '15px' }}>
                                                <InsertDriveFile />
                                                <Typography className={classes.title} style={{ textAlign: 'center', marginTop: '5px' }}>
                                                    {item.filename}
                                                </Typography>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                </div>

                <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                    {RTL ? (
                        <div dir={"rtl"} style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                            {promptAiResultUploadArray.length > 0 && (
                                <>
                                    <Typography className={classes.title} style={{ width: '100%', textAlign: 'center', marginBottom: '15px' }}>
                                        מסמכים שהועלו
                                    </Typography>

                                    <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', width: '100%', marginBottom: '15px' }}>
                                        {promptAiResultUploadArray.map((item, index) => (
                                            <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '15px' }}>
                                                <InsertDriveFile />
                                                <Typography className={classes.title} style={{ textAlign: 'center', marginTop: '5px' }}>
                                                    {item.filename}
                                                </Typography>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    ) : (
                        <div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
                            {promptAiResultUploadArray.length > 0 && (
                                <>
                                    <Typography className={classes.title} style={{ width: '100%', textAlign: 'center', marginBottom: '15px' }}>
                                        Uploaded documents
                                    </Typography>

                                    <div style={{ display: 'flex', justifyContent: 'center', flexWrap: 'wrap', width: '100%', marginBottom: '15px' }}>
                                        {promptAiResultUploadArray.map((item, index) => (
                                            <div key={index} style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', marginRight: '15px' }}>
                                                <InsertDriveFile />
                                                <Typography className={classes.title} style={{ textAlign: 'center', marginTop: '5px' }}>
                                                    {item.filename}
                                                </Typography>
                                            </div>
                                        ))}
                                    </div>
                                </>
                            )}
                        </div>
                    )}
                </div>



                <div style={{display: 'flex'}}>

                    { RTL ? <div dir={"rtl"}>
                        <TextareaAutosize  minRows={15}  name='prompt' className={ emptyQuestion ? classes.textArea + ' ' + classes.error :  classes.textArea} value={question}
                                          onChange={(e)=> {setQuestion(e.target.value);}}
                        />
                    </div> :  <TextareaAutosize  minRows={15}  name='prompt' className={ emptyQuestion ? classes.textArea + ' ' + classes.error :  classes.textArea} value={question}
                                                onChange={(e)=> {setQuestion(e.target.value);}}
                    />}
                </div>

                <div className={classes.styleBlock}>
                        <StyledButton onClick={handleAskAiClick} className={classes.button + ' ' + classes.bgSecond}>
                            <svg xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="16" height="16" viewBox="0 0 48 48">
                                <path fill="#00B298" d="M40,6H8C6.895,6,6,6.895,6,8v32c0,1.105,0.895,2,2,2h32c1.105,0,2-0.895,2-2V8	C42,6.895,41.105,6,40,6z"></path>
                                <path fill="#ffffff" d="M22.197,14.234h-4.404L10.037,33.67c0-0.096,4.452,0,4.452,0l1.484-4.069h8.234l1.58,4.069h4.261	L22.197,14.234z M17.362,26.059l2.729-6.894l2.633,6.894C22.723,26.059,17.266,26.059,17.362,26.059z"></path>
                                <path fill="#ffffff" d="M25.963,14.234L33.59,33.67h4.356l-7.803-19.436C30.144,14.234,25.963,14.186,25.963,14.234z"></path>
                            </svg>
                            <span className={classes.span  + ' ' + classes.colorSecond }>Ask claude</span>
                        </StyledButton>
                    <Tooltip title="Copy paste the *patent* number and *click here*" arrow placement="bottom">
                        <StyledButton onClick={handleAskPatentClick} className={classes.button + ' ' + classes.bgSecondFetchPatent} style={{marginLeft:'4px'}}>
                            <span className={ classes.colorSecond }>Fetch patent</span>
                        </StyledButton>
                    </Tooltip>
                </div>


                { (isLoading) && <LinearProgress color="primary" className={classes.progress}/> }


                {
                    promptAiError && !isLoading
                        ?
                        <div className={classes.aiError}>
                            <Typography className={classes.titleAiError}>
                                <span style={{marginLeft: 'auto', order: '1'}}>AI Suggests!</span>
                                <svg style={{marginLeft: 'auto', marginRight: '10px', order: '2'}} width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                    <path d="M9.34078 4.09266C9.42637 3.83888 9.47002 3.57317 9.47007 3.30571C9.47004 2.86314 9.35056 2.42856 9.12392 2.04664C8.6685 1.26448 7.8237 0.781573 6.9094 0.781573C6.72928 0.781576 6.54966 0.800346 6.37353 0.837572C6.13663 0.574218 5.84584 0.363404 5.52034 0.219031C5.19484 0.074659 4.84202 7.69704e-06 4.48514 0H4.46911L4.4631 3.48928e-05C3.35572 3.48928e-05 2.37367 0.705082 2.03325 1.74448C1.68087 1.81569 1.34797 1.96036 1.05684 2.16879C0.765717 2.37722 0.523075 2.64461 0.345161 2.95306C0.119209 3.33728 0.000138266 3.77357 0 4.21778C8.63507e-05 4.84207 0.23495 5.44412 0.659114 5.90734C0.573493 6.16111 0.529826 6.42683 0.529789 6.69429C0.529829 7.13686 0.649306 7.57144 0.87594 7.95336C1.14545 8.41636 1.55703 8.78293 2.05132 9.00023C2.54561 9.21752 3.09707 9.27431 3.62619 9.16239C3.86312 9.42575 4.15393 9.63656 4.47945 9.78094C4.80498 9.92532 5.15782 9.99998 5.51472 10H5.53074L5.53725 9.99997C6.64524 9.99997 7.62697 9.29488 7.96739 8.25454C8.31977 8.18331 8.65266 8.03863 8.94379 7.83019C9.23492 7.62176 9.47758 7.35437 9.65551 7.04593C9.88122 6.66205 10.0001 6.22612 10 5.78232C9.99992 5.15805 9.76494 4.55587 9.34078 4.09266ZM5.53138 9.34624H5.52876C5.08541 9.34609 4.65614 9.19263 4.31559 8.91253C4.33581 8.90178 4.35579 8.89061 4.37553 8.87901L6.39349 7.72891C6.44384 7.70062 6.48572 7.65969 6.51485 7.61027C6.54399 7.56084 6.55934 7.50469 6.55936 7.44752V4.63854L7.4123 5.12448C7.41678 5.12668 7.42064 5.12994 7.42353 5.13396C7.42643 5.13799 7.42827 5.14266 7.4289 5.14756V7.4722C7.42773 8.50573 6.57893 9.34414 5.53138 9.34624ZM1.4507 7.62658C1.28402 7.34221 1.1962 7.01952 1.19608 6.69101C1.19608 6.58387 1.20557 6.47644 1.22404 6.37087C1.23904 6.37974 1.26522 6.39552 1.28401 6.40617L3.30197 7.55627C3.35228 7.58525 3.40949 7.60051 3.46775 7.6005C3.52601 7.60049 3.58321 7.5852 3.63351 7.5562L6.09723 6.15257V7.12448L6.09726 7.12615C6.09726 7.13083 6.09616 7.13545 6.09404 7.13964C6.09192 7.14382 6.08885 7.14747 6.08505 7.15028L4.04508 8.31243C3.75644 8.47634 3.42926 8.56265 3.09622 8.56275C2.76283 8.5627 2.43531 8.47617 2.1465 8.31185C1.85769 8.14752 1.61774 7.91127 1.4507 7.62658ZM0.919815 3.27984C1.14145 2.89999 1.49141 2.60916 1.90845 2.45822C1.90845 2.47536 1.90746 2.50573 1.90746 2.52682V4.82706L1.90742 4.82895C1.90743 4.88606 1.92276 4.94216 1.95185 4.99154C1.98094 5.04092 2.02276 5.08182 2.07305 5.11009L4.53677 6.51352L3.68386 6.99946C3.67965 7.0022 3.67482 7.00386 3.66981 7.00431C3.66479 7.00477 3.65973 7.00398 3.65509 7.00204L1.61491 5.83892C1.3265 5.67406 1.08707 5.43731 0.920611 5.15239C0.754151 4.86747 0.666511 4.54438 0.666473 4.21551C0.666601 3.88715 0.753884 3.56447 0.919815 3.27984ZM7.92759 4.88889L5.46387 3.48529L6.31681 2.99953C6.32102 2.99679 6.32585 2.99512 6.33087 2.99467C6.33589 2.99422 6.34094 2.995 6.34558 2.99695L8.38572 4.15909C8.67437 4.32369 8.91406 4.56031 9.08072 4.8452C9.24738 5.1301 9.33515 5.45324 9.33523 5.78218C9.33523 6.56732 8.8387 7.26985 8.09212 7.54101V5.17199L8.09222 5.16934C8.09221 5.11244 8.07698 5.05654 8.04807 5.0073C8.01916 4.95806 7.9776 4.91722 7.92759 4.88889ZM8.77653 3.62819C8.75669 3.6162 8.73671 3.60444 8.71659 3.59293L6.69863 2.44279C6.64831 2.41386 6.59113 2.39861 6.5329 2.39859C6.47466 2.39861 6.41748 2.41386 6.36716 2.44279L3.90341 3.84642V2.87451L3.90338 2.87283C3.90338 2.86334 3.90794 2.8544 3.91562 2.84871L5.95559 1.68754C6.24414 1.5234 6.57135 1.43699 6.90442 1.43698C7.95331 1.43698 8.80391 2.27626 8.80391 3.31119C8.80386 3.41739 8.7947 3.52351 8.77653 3.62819ZM3.43968 5.36045L2.58656 4.87451C2.58209 4.87231 2.57823 4.86905 2.57534 4.86502C2.57244 4.861 2.5706 4.85633 2.56997 4.85143V2.52675C2.57043 1.49238 3.42104 0.653796 4.46947 0.653796C4.91351 0.653887 5.34351 0.807371 5.68484 1.08761C5.66948 1.09589 5.6427 1.11048 5.6249 1.12113L3.60694 2.27123C3.55659 2.2995 3.51472 2.34041 3.48559 2.38982C3.45646 2.43922 3.44111 2.49536 3.4411 2.55252V2.55437L3.43968 5.36045ZM3.90302 4.37478L5.00032 3.74944L6.09761 4.37436V5.62463L5.00032 6.24959L3.90302 5.62463V4.37478Z" fill="#FF5959"/>
                                </svg>
                            </Typography>
                            <div className={classes.aiErrorContent}>
                                <ErrorIcon fontSize='large' htmlColor='rgba(255, 89, 89, 0.15)' className={classes.aiErrorIcon}/>
                                {/*<span className={classes.aiErrorText}>Error - please try to refresh or rephrase your search</span>*/}
                                <span className={classes.aiErrorText}>{promptAiErrorText ? promptAiErrorText : 'Server Error'}</span>
                            </div>
                        </div>
                        :
                        promptAiResult && !isLoading ?
                        <>
                            <div className={classes.styleForBlockSuggest}>
                                <Typography className={classes.title}>
                                    <svg width="12" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M9.34078 4.09266C9.42637 3.83888 9.47002 3.57317 9.47007 3.30571C9.47004 2.86314 9.35056 2.42856 9.12392 2.04664C8.6685 1.26448 7.8237 0.781573 6.9094 0.781573C6.72928 0.781576 6.54966 0.800346 6.37353 0.837572C6.13663 0.574218 5.84584 0.363404 5.52034 0.219031C5.19484 0.074659 4.84202 7.69704e-06 4.48514 0H4.46911L4.4631 3.48928e-05C3.35572 3.48928e-05 2.37367 0.705082 2.03325 1.74448C1.68087 1.81569 1.34797 1.96036 1.05684 2.16879C0.765717 2.37722 0.523075 2.64461 0.345161 2.95306C0.119209 3.33728 0.000138266 3.77357 0 4.21778C8.63507e-05 4.84207 0.23495 5.44412 0.659114 5.90734C0.573493 6.16111 0.529826 6.42683 0.529789 6.69429C0.529829 7.13686 0.649306 7.57144 0.87594 7.95336C1.14545 8.41636 1.55703 8.78293 2.05132 9.00023C2.54561 9.21752 3.09707 9.27431 3.62619 9.16239C3.86312 9.42575 4.15393 9.63656 4.47945 9.78094C4.80498 9.92532 5.15782 9.99998 5.51472 10H5.53074L5.53725 9.99997C6.64524 9.99997 7.62697 9.29488 7.96739 8.25454C8.31977 8.18331 8.65266 8.03863 8.94379 7.83019C9.23492 7.62176 9.47758 7.35437 9.65551 7.04593C9.88122 6.66205 10.0001 6.22612 10 5.78232C9.99992 5.15805 9.76494 4.55587 9.34078 4.09266ZM5.53138 9.34624H5.52876C5.08541 9.34609 4.65614 9.19263 4.31559 8.91253C4.33581 8.90178 4.35579 8.89061 4.37553 8.87901L6.39349 7.72891C6.44384 7.70062 6.48572 7.65969 6.51485 7.61027C6.54399 7.56084 6.55934 7.50469 6.55936 7.44752V4.63854L7.4123 5.12448C7.41678 5.12668 7.42064 5.12994 7.42353 5.13396C7.42643 5.13799 7.42827 5.14266 7.4289 5.14756V7.4722C7.42773 8.50573 6.57893 9.34414 5.53138 9.34624ZM1.4507 7.62658C1.28402 7.34221 1.1962 7.01952 1.19608 6.69101C1.19608 6.58387 1.20557 6.47644 1.22404 6.37087C1.23904 6.37974 1.26522 6.39552 1.28401 6.40617L3.30197 7.55627C3.35228 7.58525 3.40949 7.60051 3.46775 7.6005C3.52601 7.60049 3.58321 7.5852 3.63351 7.5562L6.09723 6.15257V7.12448L6.09726 7.12615C6.09726 7.13083 6.09616 7.13545 6.09404 7.13964C6.09192 7.14382 6.08885 7.14747 6.08505 7.15028L4.04508 8.31243C3.75644 8.47634 3.42926 8.56265 3.09622 8.56275C2.76283 8.5627 2.43531 8.47617 2.1465 8.31185C1.85769 8.14752 1.61774 7.91127 1.4507 7.62658ZM0.919815 3.27984C1.14145 2.89999 1.49141 2.60916 1.90845 2.45822C1.90845 2.47536 1.90746 2.50573 1.90746 2.52682V4.82706L1.90742 4.82895C1.90743 4.88606 1.92276 4.94216 1.95185 4.99154C1.98094 5.04092 2.02276 5.08182 2.07305 5.11009L4.53677 6.51352L3.68386 6.99946C3.67965 7.0022 3.67482 7.00386 3.66981 7.00431C3.66479 7.00477 3.65973 7.00398 3.65509 7.00204L1.61491 5.83892C1.3265 5.67406 1.08707 5.43731 0.920611 5.15239C0.754151 4.86747 0.666511 4.54438 0.666473 4.21551C0.666601 3.88715 0.753884 3.56447 0.919815 3.27984ZM7.92759 4.88889L5.46387 3.48529L6.31681 2.99953C6.32102 2.99679 6.32585 2.99512 6.33087 2.99467C6.33589 2.99422 6.34094 2.995 6.34558 2.99695L8.38572 4.15909C8.67437 4.32369 8.91406 4.56031 9.08072 4.8452C9.24738 5.1301 9.33515 5.45324 9.33523 5.78218C9.33523 6.56732 8.8387 7.26985 8.09212 7.54101V5.17199L8.09222 5.16934C8.09221 5.11244 8.07698 5.05654 8.04807 5.0073C8.01916 4.95806 7.9776 4.91722 7.92759 4.88889ZM8.77653 3.62819C8.75669 3.6162 8.73671 3.60444 8.71659 3.59293L6.69863 2.44279C6.64831 2.41386 6.59113 2.39861 6.5329 2.39859C6.47466 2.39861 6.41748 2.41386 6.36716 2.44279L3.90341 3.84642V2.87451L3.90338 2.87283C3.90338 2.86334 3.90794 2.8544 3.91562 2.84871L5.95559 1.68754C6.24414 1.5234 6.57135 1.43699 6.90442 1.43698C7.95331 1.43698 8.80391 2.27626 8.80391 3.31119C8.80386 3.41739 8.7947 3.52351 8.77653 3.62819ZM3.43968 5.36045L2.58656 4.87451C2.58209 4.87231 2.57823 4.86905 2.57534 4.86502C2.57244 4.861 2.5706 4.85633 2.56997 4.85143V2.52675C2.57043 1.49238 3.42104 0.653796 4.46947 0.653796C4.91351 0.653887 5.34351 0.807371 5.68484 1.08761C5.66948 1.09589 5.6427 1.11048 5.6249 1.12113L3.60694 2.27123C3.55659 2.2995 3.51472 2.34041 3.48559 2.38982C3.45646 2.43922 3.44111 2.49536 3.4411 2.55252V2.55437L3.43968 5.36045ZM3.90302 4.37478L5.00032 3.74944L6.09761 4.37436V5.62463L5.00032 6.24959L3.90302 5.62463V4.37478Z" fill="#10A37F"/>
                                    </svg>
                                    <span style={{marginLeft: '8px'}}>AI answer:</span>
                                </Typography>
                                <div style={{width: '25px', marginRight: '5px'}}>
                                    <div  style={{display: 'flex'}} >
                                        <Tooltip title="copy text" arrow placement="bottom">
                                            <StyledButton onClick={handleClick} className={classes.noBg}>
                                                <svg width="12" height="13" viewBox="0 0 11 13" fill="none" xmlns="http://www.w3.org/2000/svg">
                                                    <path d="M9.29165 2.70834H3.33331C3.046 2.70834 2.77045 2.82248 2.56728 3.02564C2.36412 3.2288 2.24998 3.50435 2.24998 3.79167V11.375C2.24998 11.6623 2.36412 11.9379 2.56728 12.141C2.77045 12.3442 3.046 12.4583 3.33331 12.4583H9.29165C9.57897 12.4583 9.85452 12.3442 10.0577 12.141C10.2608 11.9379 10.375 11.6623 10.375 11.375V3.79167C10.375 3.50435 10.2608 3.2288 10.0577 3.02564C9.85452 2.82248 9.57897 2.70834 9.29165 2.70834ZM7.66665 0.541672H1.16665C0.879328 0.541672 0.603778 0.655808 0.400614 0.858973C0.19745 1.06214 0.083313 1.33769 0.083313 1.62501V9.20834H1.16665V1.62501H7.66665V0.541672Z" fill="#1174E5"/>
                                                </svg>
                                            </StyledButton>
                                        </Tooltip>

                                    </div>
                                </div>
                            </div>
                            <p className={classes.textAreaResult}>
                                {result}
                            </p>

                        </> : null

                }


            </div>
            <div style={{display: 'flex', height: '1px'}}></div>
        </div>
    );
}
